export const animationDirection = {
    TOLEFT: 'toLeft',
    TORIGHT: 'toRight'
}